/**
 * Accounts Feature API
 * 
 * This file contains all API methods for the Accounts feature.
 * It uses the shared apiClient for consistency.
 * 
 * This is part of the feature-based architecture to enable parallel development.
 */

import apiClient from '../../../shared/services/apiClient';

export const accountsAPI = {
  getAll: (params) => apiClient.get('/accounts', { params }),
  getById: (id) => apiClient.get(`/accounts/${id}`),
  getSummary: (id) => apiClient.get(`/accounts/${id}/summary`),
  getByAsset: (params) => apiClient.get('/accounts/by-asset', { params }),
  create: (data) => apiClient.post('/accounts', data),
  update: (id, data) => apiClient.put(`/accounts/${id}`, data),
  delete: (id) => apiClient.delete(`/accounts/${id}`),
};

export default accountsAPI;

